import StaticTimeAgo from "../../shared/StaticTimeAgo";
import StreamList from "./StreamList";
import { ObjectWithContent } from "@/@types/activities.ts";
import { Activitystream } from "@/api/activitystreams.ts";
import UpdatedIndicator from "../../shared/UpdatedIndicator.tsx";
import ArchivedIndicator from "./ArchivedIndicator.tsx";

type ActivityMetaArgs = {
  activityId: string;
  published: string;
  contentUpdatedAt?: string | null;
  contentUpdatedBy?: ObjectWithContent["content_updated_by"];
  actorUpdatedAt?: string | null;
  actorUpdatedBy?: { name: string } | null;
  archivedAt?: string | null;
  archivedByName?: string | null;
  isNew?: boolean;
  error?: boolean;
  foreignActivityStreams?: Activitystream[];
  streamsFromActivity?: Activitystream[];
};

function pickLatestEdit(
  contentUpdatedAt?: string | null,
  contentUpdatedByName?: string,
  actorUpdatedAt?: string | null,
  actorUpdatedByName?: string,
) {
  if (!contentUpdatedAt && !actorUpdatedAt) return null;

  const contentIsNewer =
    contentUpdatedAt &&
    (!actorUpdatedAt || new Date(contentUpdatedAt) >= new Date(actorUpdatedAt));

  return contentIsNewer
    ? {
        updatedAt: contentUpdatedAt as string,
        updatedByName: contentUpdatedByName,
      }
    : {
        updatedAt: actorUpdatedAt as string,
        updatedByName: actorUpdatedByName,
      };
}

export default function ActivityMeta({
  activityId,
  isNew,
  published,
  contentUpdatedBy,
  contentUpdatedAt,
  actorUpdatedAt,
  actorUpdatedBy,
  archivedAt,
  archivedByName,
  foreignActivityStreams,
  streamsFromActivity,
  error = false,
}: ActivityMetaArgs) {
  const latestEdit = pickLatestEdit(
    contentUpdatedAt,
    contentUpdatedBy?.name,
    actorUpdatedAt,
    actorUpdatedBy?.name,
  );

  return isNew ? (
    <span className="published-in text-muted leading-none text-sm">
      {I18n.t("activity.saving")}
    </span>
  ) : (
    <>
      {((streamsFromActivity?.length || 0) > 0 ||
        (foreignActivityStreams?.length || 0) > 0) && (
        <div className="published-in">
          <StreamList
            streamsFromActivity={streamsFromActivity}
            foreignActivityStreams={foreignActivityStreams}
          />
        </div>
      )}
      {!error && (
        <div className="flex leading-none text-sm text-muted gap-1 -mt-1">
          <a
            className="text-muted text-sm leading-none"
            href={`/activities/${activityId}`}
          >
            <StaticTimeAgo date={published} />
          </a>
          {latestEdit && (
            <UpdatedIndicator
              updatedAt={latestEdit.updatedAt}
              updatedByName={latestEdit.updatedByName}
              separatorBefore
            />
          )}
          {archivedAt && (
            <ArchivedIndicator
              archivedAt={archivedAt}
              archivedByName={archivedByName}
              separatorBefore
            />
          )}
        </div>
      )}
    </>
  );
}
